import { Box, Grid, IconButton, Typography, styled } from "@mui/material";

import { Link } from "react-router-dom";

export function HeaderWallet({ hasMargin, itemHeader , my = 2 }) {
  return (
    <Grid
      item
      xs={12}
      display="flex"
      justifyContent="space-between"
      flexDirection="row-reverse"
      alignItems="center"
      my={my}
    >
      <BoxHeader>
        {itemHeader.map((item) => (
          <IconButton
            aria-label="history"
            size="small"
            component={Link}
            to={item.link}
            onClick={() => {
              window.location.href = item.link;
            }}
            sx={{ ml: 1 }}
          >
            {item.icon}
          </IconButton>
        ))}
      </BoxHeader>
      {hasMargin && <Title component="h1">Margin Level</Title>}
    </Grid>
  );
}

const BoxHeader = styled(Box)(({ theme }) => ({
  "ion-icon": {
    color: theme.palette.secondary.main,
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  fontWeight: 700,
  color: theme.palette.text.main,
}));

export default HeaderWallet;
